"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInstanceId = exports.setBalanceListenerActionName = exports.setBalanceDetails = exports.getBalanceDetailsSuccess = exports.getBalanceDetailsRequest = exports.getBalanceDetailsFailure = exports.SET_PARAMS = exports.SET_INSTANCE_ID = exports.SET_BALANCE_LISTENER_ACTIONS = exports.SET_BALANCE_DETAILS = exports.GET_BALANCE_DETAILS_SUCCESS = exports.GET_BALANCE_DETAILS_REQUEST = exports.GET_BALANCE_DETAILS_FAILURE = void 0;

var _appConstants = require("../appConstants");

var GET_BALANCE_DETAILS_REQUEST = "@".concat(_appConstants.pkgName, "/GET_BALANCE_DETAILS_REQUEST");
exports.GET_BALANCE_DETAILS_REQUEST = GET_BALANCE_DETAILS_REQUEST;
var GET_BALANCE_DETAILS_SUCCESS = "@".concat(_appConstants.pkgName, "/GET_BALANCE_DETAILS_SUCCESS");
exports.GET_BALANCE_DETAILS_SUCCESS = GET_BALANCE_DETAILS_SUCCESS;
var GET_BALANCE_DETAILS_FAILURE = "@".concat(_appConstants.pkgName, "/GET_BALANCE_DETAILS_FAILURE");
exports.GET_BALANCE_DETAILS_FAILURE = GET_BALANCE_DETAILS_FAILURE;
var SET_PARAMS = "@".concat(_appConstants.pkgName, "/SET_PARAMS");
exports.SET_PARAMS = SET_PARAMS;
var SET_BALANCE_DETAILS = "@".concat(_appConstants.pkgName, "/SET_BALANCE_DETAILS");
exports.SET_BALANCE_DETAILS = SET_BALANCE_DETAILS;
var SET_INSTANCE_ID = "@".concat(_appConstants.pkgName, "/SET_INSTANCE_ID");
exports.SET_INSTANCE_ID = SET_INSTANCE_ID;
var SET_BALANCE_LISTENER_ACTIONS = "@".concat(_appConstants.pkgName, "/SET_BALANCE_LISTENER_ACTIONS");
exports.SET_BALANCE_LISTENER_ACTIONS = SET_BALANCE_LISTENER_ACTIONS;

var getBalanceDetailsRequest = function getBalanceDetailsRequest() {
  return {
    type: GET_BALANCE_DETAILS_REQUEST
  };
};

exports.getBalanceDetailsRequest = getBalanceDetailsRequest;

var getBalanceDetailsSuccess = function getBalanceDetailsSuccess(response, balancePath) {
  return {
    type: GET_BALANCE_DETAILS_SUCCESS,
    payload: {
      response: response,
      balancePath: balancePath
    }
  };
};

exports.getBalanceDetailsSuccess = getBalanceDetailsSuccess;

var getBalanceDetailsFailure = function getBalanceDetailsFailure(err) {
  return {
    type: GET_BALANCE_DETAILS_FAILURE,
    payload: err
  };
};

exports.getBalanceDetailsFailure = getBalanceDetailsFailure;

var setBalanceDetails = function setBalanceDetails(payload) {
  return {
    type: SET_BALANCE_DETAILS,
    payload: payload
  };
};

exports.setBalanceDetails = setBalanceDetails;

var setInstanceId = function setInstanceId(id) {
  return {
    type: SET_INSTANCE_ID,
    payload: {
      id: id
    }
  };
};

exports.setInstanceId = setInstanceId;

var setBalanceListenerActionName = function setBalanceListenerActionName(listOfActions) {
  return {
    type: SET_BALANCE_LISTENER_ACTIONS,
    payload: listOfActions
  };
};

exports.setBalanceListenerActionName = setBalanceListenerActionName;